<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form"
                    :model="model"
                    :rules="validatorRules"
                    slot="detail">

        <a-form-model-item :label="language['gift_tag_name']"
                           :labelCol="labelCol"
                           :wrapperCol="wrapperCol"
                           prop="label">
          <a-input v-model="model.label"
                   :placeholder="language['common.pleaseInput'] + language['gift_tag_name']"></a-input>
        </a-form-model-item>

        <a-form-model-item :label="language['gift_tag_group']"
                           :labelCol="labelCol"
                           :wrapperCol="wrapperCol"
                           prop="groupName">
          <j-dict-select-tag v-model="model.groupName"
                             :placeholder="language['common.pleaseChoose'] + language['gift_tag_group']"
                             :type="list"
                             dictCode="gift_tag" />
        </a-form-model-item>

        <a-form-model-item :label="language['gift_user_app']"
                           :labelCol="labelCol"
                           :wrapperCol="wrapperCol"
                           prop="app">
          <a-select v-model="model.app"
                    :placeholder="language['common.pleaseChoose'] + language['gift_user_app']"
                    :options="appList"
                    @change="handlerApp"
                    :disabled="isDisabled">
          </a-select>
        </a-form-model-item>

        <a-form-model-item :label="language['common.sort']"
                           :labelCol="labelCol"
                           :wrapperCol="wrapperCol"
                           prop="sort">
          <a-input v-model="model.sort"></a-input>
        </a-form-model-item>

        <a-form-model-item :label="language['serial.activeFlag']"
                           :labelCol="labelCol"
                           :wrapperCol="wrapperCol">
          <j-switch v-model="model.status"
                    @change="changeSwitch"></j-switch>
        </a-form-model-item>

      </a-form-model>
    </j-form-container>

  </a-spin>
</template>

<script>
import { httpAction, getAction } from '@/api/manage'

export default {
  name: 'WasteCategoryModal',
  components: {},
  props: {
    appList: {
      type: Array,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    const language = this.$store.getters.language
    return {
      title: '新增',
      width: 800,
      visible: false,
      disableSubmit: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      isDisabled: false,
      confirmLoading: false,
      validatorRules: {
        label: [{ required: true, message: language['common.pleaseInput'] + language['gift_tag_name'] }],
        // label: [
        //   { required: true, message: this.language['common.pleaseInput'] + this.language['epi_type_name'] },
        //   //   { validator: (rule, value, callback) => this.validateDuplicateValue(value, callback) },
        //   { max: 50, message: this.language['common.lengthUnder'] + '50', trigger: 'blur' },
        // ],

        groupName: [{ required: true, message: language['common.pleaseChoose'] + language['gift_tag_group'] }],
        app: [{ required: true, message: language['common.pleaseChoose'] + language['gift_user_app'] }],
        //   status: [{ required: true, message: '请选择是否启用!' }],
      },
      url: {
        add: '/gift/product/tag/add',
        edit: '/gift/product/tag/edit',
      },
    }
  },
  created() {
    this.modelDefault = JSON.parse(JSON.stringify(this.model))
  },
  computed: {
    formDisabled() {
      return this.disabled
    },
    language() {
      return this.$store.getters.language
    },
  },
  methods: {
    add() {
      this.edit(this.modelDefault)
      this.model.status = 'Y'
    },
    edit(record) {
      this.model = Object.assign({}, record)
      this.model.status = this.model.status === 1 ? 'Y' : 'N'
      this.visible = true
      this.isDisabled = record.id ? true : false
    },
    close() {
      this.$emit('close')
      this.visible = false
      this.$refs.form.resetFields()
    },
    submitForm() {
      const that = this
      // 触发表单验证
      this.$refs.form.validate((valid) => {
        if (valid) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          if (!this.model.id) {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'put'
          }
          this.model.groupId = this.model.groupName
          this.model.status = this.model.status === 'Y' ? 1 : 0
          console.log('handleOk model : ', this.model)
          httpAction(httpurl, this.model, method)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
                that.close()
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
            })
        } else {
          return false
        }
      })
    },
    handleCancel() {
      this.close()
    },
    changeSwitch(val) {
      console.log('changeSwitch : ', val)
      // this.model.status = val
    },
  },
}
</script>